<script setup lang="ts">
// Material "filter_alt" — filter control. Colour follows CSS `color`.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    v-bind="$attrs"
  >
    <path
      d="M9.16681 16.6667C8.9307 16.6667 8.73278 16.5869 8.57306 16.4272C8.41334 16.2674 8.33347 16.0695 8.33347 15.8334V10.8334L3.50014 4.66674C3.29181 4.38896 3.26056 4.0973 3.40639 3.79174C3.55222 3.48619 3.8057 3.33341 4.16681 3.33341H15.8335C16.1946 3.33341 16.4481 3.48619 16.5939 3.79174C16.7397 4.0973 16.7085 4.38896 16.5001 4.66674L11.6668 10.8334V15.8334C11.6668 16.0695 11.5869 16.2674 11.4272 16.4272C11.2675 16.5869 11.0696 16.6667 10.8335 16.6667H9.16681ZM10.0001 10.2501L14.1251 5.00007H5.87514L10.0001 10.2501Z"
      fill="currentColor"
    />
  </svg>
</template>
